import { render } from "./ZoneExecutiveList.vue?vue&type=template&id=c89d7b2a&scoped=true"
import script from "./ZoneExecutiveList.vue?vue&type=script&lang=js"
export * from "./ZoneExecutiveList.vue?vue&type=script&lang=js"

import "./ZoneExecutiveList.vue?vue&type=style&index=0&id=c89d7b2a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c89d7b2a"]])

export default __exports__